import { findUser } from 'api';
import allSettled from 'promise.allsettled';
import {
  BUSINESS_ADMIN,
  BUSINESS_AGENT,
  RESELLER_ADMIN,
  RESELLER_AGENT,
} from 'permissions/userGroups';

export const isReseller = (user) => user?.acl_group_name === 'RESELLER';
export const isB2b = (user) =>
  user &&
  (user.acl_group_name === 'RESELLER' || user.acl_group_name === 'BUSINESS');
export const isResold = (user) => user?.acl_group_name === 'RESOLD_USER';
export const isBusinessChild = (user) =>
  user &&
  (user.acl_group_name === 'BUSINESS_ADMIN' ||
    user.acl_group_name === 'BUSINESS_AGENT');
export const isResellerChild = (user) =>
  user &&
  (user.acl_group_name === 'RESELLER_ADMIN' ||
    user.acl_group_name === 'RESELLER_AGENT');
export const isB2bStaff = (user) => {
  if (!user) return false;

  return [
    BUSINESS_ADMIN,
    BUSINESS_AGENT,
    RESELLER_ADMIN,
    RESELLER_AGENT,
  ].includes(user.acl_group_name);
};
export const attachUserForEachUserProfile = async (results) => {
  const userIds = [
    ...new Set(results && results.map((result) => result.user_profile)),
  ];
  if (userIds && userIds.length !== 0) {
    const userPromises = userIds.map(findUser);
    const userResponses = await allSettled(userPromises);
    const users = userResponses
      .filter(({ status }) => (status === 'fulfilled' ? true : false))
      .map(({ value: { data } }) => data);

    return results.map((result) => {
      const user = users.find((user) => user.id === result.user_profile);
      return {
        ...result,
        user,
      };
    });
  }
};

export const allAclGroups = [
  'ADMIN',
  'READ_ONLY_ADMIN',
  'MANAGER',
  'AGENT',
  'BUSINESS',
  'USER',
  'RESELLER',
  'RESOLD_USER',
  'BILLING',
  'TRAINEE',
];
export const userAclGroups = [
  'USER',
  'RESELLER',
  'BUSINESS',
  'ADMIN',
  'MANAGER',
  'AGENT',
  'BILLING',
  'TRAINEE',
];
export const resellerUserAclGroups = ['USER', 'RESOLD_USER'];
export const managerUserAclGroups = ['USER', 'RESOLD_USER'];
export const businessChildAclGroups = ['BUSINESS_ADMIN', 'BUSINESS_AGENT'];
export const resellerChildAclGroups = ['RESELLER_ADMIN', 'RESELLER_AGENT'];
export const caretUserNavSafariFix = () => {
  const caretId = 'user-nav-caret';
  const caret = document.getElementById(caretId);

  if (caret) {
    setTimeout(() => {
      caret.style.right = '-22px';
      setTimeout(() => {
        caret.style.right = '-21px';
      }, 100);
    }, 200);
  }
};
export const filterUserAclChoices = (user, choices) => {
  if (!user || !choices) {
    return [];
  }
  const isB2bChild = isResellerChild(user) || isBusinessChild(user);
  if (isB2bChild) {
    return choices;
  }

  const choicesToExclude = [
    ...resellerChildAclGroups,
    ...businessChildAclGroups,
  ];
  return choices.filter(({ value }) => {
    return !choicesToExclude.includes(value);
  });
};
